// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-about-js": require("gatsby-module-loader?name=component---src-pages-about-js!/opt/build/repo/src/pages/about.js"),
  "component---src-pages-contact-js": require("gatsby-module-loader?name=component---src-pages-contact-js!/opt/build/repo/src/pages/contact.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-locations-js": require("gatsby-module-loader?name=component---src-pages-locations-js!/opt/build/repo/src/pages/locations.js"),
  "component---src-pages-menu-js": require("gatsby-module-loader?name=component---src-pages-menu-js!/opt/build/repo/src/pages/menu.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "about.json": require("gatsby-module-loader?name=path---about!/opt/build/repo/.cache/json/about.json"),
  "contact.json": require("gatsby-module-loader?name=path---contact!/opt/build/repo/.cache/json/contact.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "locations.json": require("gatsby-module-loader?name=path---locations!/opt/build/repo/.cache/json/locations.json"),
  "menu.json": require("gatsby-module-loader?name=path---menu!/opt/build/repo/.cache/json/menu.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js